import React, {
  memo,
  useMemo,
} from 'react';

import { formatName } from '../../../../shared/utils';
import { IUserReviewsFilters } from '../../../../types/tqConnectTypes/user';
import { UserAccountType } from '../../../../types/userTypes';
import NoDataFound from '../../../Feed/components/NoDataFound/NoDataFound';

interface Props {
  userName: string;
  viewerType: UserAccountType;
  isViewerSelf?: boolean;
  filters: IUserReviewsFilters;
}

const NoReviews: React.FC<Props> = ({ userName, isViewerSelf, filters }) => {
  const renderedNoReviewsContent = useMemo(() => {
    const { type, rating } = filters;

    const firstName = formatName(userName, {
      nameType: 'first',
    });

    let title = `No reviews ${type === 'received' ? 'received' : 'given'} yet!`;
    let subtitle = isViewerSelf
      ? (type === 'received' &&
          'Once someone you help marks your service as complete and leaves feedback, their reviews will show up here.') ||
        'Reviews given by you will appear here.'
      : `Reviews ${type === 'received' ? 'received' : 'given'}  by ${firstName} will appear here.`;

    // check if any reviews filters are applied
    if (rating) {
      title = 'Oops! No reviews found!';
      subtitle = `Sorry, we didn't find any matching results`;
    }

    return <NoDataFound title={title} subtitle={subtitle} />;
  }, [filters, isViewerSelf, userName]);

  return renderedNoReviewsContent;
};

export default memo(NoReviews);
